import Edit from '@/components/toolbox/user/Edit'
import _ from 'lodash'

class User {
  constructor (data) {
    // wir wollen die vuex watcher los werden
    let myData = _.cloneDeep(data)
    this.id = myData.id
    this.avatar = myData.avatar
    this.firstName = myData.firstName
    this.friendlyName = myData.friendlyName
    this.fullName = myData.fullName
    this.lastName = myData.lastName
    this.mail = myData.mail
    this.readonly = false
  }

  getToolboxTabs () {
    return {
      edit: {
        tab: Edit,
        icon: 'edit'
      }
    }
  }
}

export default User
